import { api_get } from "services/api"
import { setSnackbar } from "../search/searchActions"

export const getSgc = (stations=[]) => {
  const  params = stations.map(station => station.label).join('&stations=')
  const base = `${process.env.REACT_APP_URL}`
  const qui = `${process.env.REACT_APP_QID_SGC}`
  const url = `${base}/sync/gn3/routes?qid=${qui}&stations=${params}`

  return async dispatch => {
    await api_get(url).then(res => {
      dispatch({
        type: 'GET_SGC',
        payload: res
      })
    }).catch(err => {
      dispatch( setSnackbar(err) )
    })
  }
}